import { doc } from 'firebase/firestore';
import { useContext, useMemo } from 'react';
import { useDocument } from 'react-firebase-hooks/firestore';
import { FirebaseAppContext, FirebaseAuthContext } from 'libs.firebase_react';
import { CodedError } from 'libs.localization.common';
import { Localization } from 'libs.localization.web';
export function useLocalizationResource(asset, locale, version) {
    const { db } = useContext(FirebaseAppContext);
    const { userClaims, loading: loadingAuth, error: errorAuth } = useContext(FirebaseAuthContext);
    const entityId = userClaims === null || userClaims === void 0 ? void 0 : userClaims.entityId;
    const localization = useMemo(() => {
        if (!asset) {
            return undefined;
        }
        try {
            return new Localization(asset);
        }
        catch (error) {
            if (!(error instanceof CodedError && error.code === 'E_ASSET_NOT_SUPPORTED')) {
                throw error;
            }
            console.error(error.message, asset);
            return undefined;
        }
    }, [asset]);
    const [resourceDocRef, resourceDocPrevRef] = useMemo(() => {
        if (!db || !entityId || !localization || !locale || typeof version !== 'number' || version < 1) {
            return [null, null];
        }
        const id = localization.getId();
        // Product strings don't store per-locale versioned resource documents in this collection.
        if (/product_/.test(id)) {
            return [null, null];
        }
        const docId = `${locale}~${version}`;
        const prevVersionDocId = `${locale}~${version - 1}`;
        const path = `entities/${entityId}/localization/${id}/localization_resources`;
        return [doc(db, path, docId), doc(db, path, prevVersionDocId)];
    }, [db, entityId, localization, locale, version]);
    const [snapshot, loadingDoc, errorDoc] = useDocument(resourceDocRef);
    let localizationResourceEntry = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data();
    const [snapshotPrev, loadingDocPrev, errorDocPrev] = useDocument(resourceDocPrevRef);
    const localizationResourceEntryPrev = snapshotPrev === null || snapshotPrev === void 0 ? void 0 : snapshotPrev.data();
    // Data bug fix: fill in potential missing library_resource_id (in such case also update base_locale_version).
    if (localizationResourceEntry && version && localizationResourceEntryPrev) {
        if (!localizationResourceEntry.library_resource_id && version >= 2) {
            const { base_locale_version, library_resource_id, library_translation_id } = localizationResourceEntryPrev;
            if (base_locale_version && library_resource_id) {
                localizationResourceEntry = Object.assign(Object.assign(Object.assign({}, localizationResourceEntry), { base_locale_version,
                    library_resource_id }), (library_translation_id ? { library_translation_id } : {}));
            }
        }
    }
    return {
        isLoading: loadingAuth || loadingDoc || loadingDocPrev,
        error: errorAuth || errorDoc || errorDocPrev,
        localizationResourceEntry,
    };
}
//# sourceMappingURL=localization_resource.hook.js.map